<script setup lang="ts">
/**
 * AiBadgePill — mandatory teal badge for AI-generated or AI-suggested content.
 * CLAUDE.md non-negotiable: every AI content piece must carry this or BaseBadge variant="ai".
 * Teal = AI signal only (brief §12).
 */
interface Props {
  label?: string;
}
const props = withDefaults(defineProps<Props>(), { label: 'AI' });
</script>

<template>
  <span
    class="inline-flex items-center gap-1 px-2 h-[22px] text-caption font-medium rounded-pill border whitespace-nowrap bg-teal-100 text-teal-700 border-teal-100"
  >
    <span class="inline-block w-1.5 h-1.5 rounded-pill bg-teal-600" aria-hidden="true" />
    {{ props.label }}
  </span>
</template>
